import React, { useEffect, useState } from 'react';
import {
  Button,
  DrawerBody,
  DrawerHeader,
  DrawerHeaderTitle,
  Field,
  Input,
  OverlayDrawer,
} from '@fluentui/react-components';
import { DismissRegular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';
import { ContractNegotiationVersion } from '../../../models/Entities/Contracts/ContractNegotiationVersion';
import { NewContractNegotiationVersion } from '../../../models/Entities/Contracts/NewContractNegotiationVersion';
import { useContractNegotiationVersionFormStyles } from './ContractNegotiationVersionForm.Styles';

interface Props {
  contractNegotiationId: string;
  contractId: number;
  version?: ContractNegotiationVersion;
  isOpen: boolean;
  onDismiss: () => void;
  onSave: (entity: NewContractNegotiationVersion | ContractNegotiationVersion) => void;
}

const toDateInputValue = (date: Date | undefined | null): string => {
  if (!date) return '';
  const d = new Date(date as Date);
  if (isNaN(d.getTime())) return '';
  return d.toISOString().slice(0, 10);
};

const ContractNegotiationVersionFormComponent = (props: Props) => {
  const { t } = useTranslation();
  const styles = useContractNegotiationVersionFormStyles();

  const [negotiationDate, setNegotiationDate] = useState<string>('');

  useEffect(() => {
    if (props.isOpen) {
      setNegotiationDate(toDateInputValue(props.version?.negotiationDate));
    }
  }, [props.isOpen, props.version]);

  const handleSave = () => {
    const base: NewContractNegotiationVersion = {
      contractNegotiationId: props.contractNegotiationId,
      negotiationDate: negotiationDate ? new Date(negotiationDate) : undefined,
    };

    if (props.version?.id) {
      props.onSave({ ...props.version, ...base });
    } else {
      props.onSave(base);
    }
  };

  const isEdit = !!props.version?.id;
  const dialogTitle = isEdit
    ? t('contractNegotiationVersionForm.titleEdit', 'Editar versión de negociación')
    : t('contractNegotiationVersionForm.titleNew', 'Nueva versión de negociación');

  return (
    <OverlayDrawer position="end" size="medium" open={props.isOpen}
      onOpenChange={(_, { open }) => { if (!open) props.onDismiss(); }}>
      <DrawerHeader>
        <DrawerHeaderTitle
          action={<Button appearance="subtle" icon={<DismissRegular />} onClick={props.onDismiss} />}>
          {dialogTitle}
        </DrawerHeaderTitle>
      </DrawerHeader>
      <DrawerBody>
        <div className={styles.form}>
          <div className={styles.formRow}>
            <Field label={t('contractNegotiationVersionForm.fields.negotiationDate', 'Fecha de negociación')}>
              <Input
                type="date"
                value={negotiationDate}
                onChange={(_, data) => setNegotiationDate(data.value)}
              />
            </Field>
          </div>
        </div>
        <div className={styles.formActions}>
          <Button appearance="secondary" onClick={props.onDismiss}>
            {t('contractNegotiationVersionForm.actions.cancel', 'Cancelar')}
          </Button>
          <Button appearance="primary" onClick={handleSave}>
            {t('contractNegotiationVersionForm.actions.save', 'Guardar')}
          </Button>
        </div>
      </DrawerBody>
    </OverlayDrawer>
  );
};

export default ContractNegotiationVersionFormComponent;
